export enum ModalButtonResponseEnum {
  OK = 'ok',
  CANCEL = 'cancel',
  PRINT = 'print',
  CLOSE = 'close', // Use with fullModal.
  HIDE = 'hide'
}
